// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1yHwF","right":"Footer_right__V16il","buttons":"Footer_buttons__21hXw"};